// SEOTab.js
import React from 'react';
import { QualityCheck } from '../../../features/articles';

const SEOTab = ({ qualityReport, onCheckQuality, isCheckingQuality }) => {
  return (
    <div>
      <QualityCheck
        qualityReport={qualityReport}
        onCheckQuality={onCheckQuality}
        isCheckingQuality={isCheckingQuality}
      />
    </div>
  );
};

export default SEOTab;